"use client";

import { cn } from "@/lib/utils";
import Image from "next/image";
import BasicBlock from "../shared/basic-block";
import { BentoGrid, BentoGridItem } from "../ui/bento-grid";
import { CDN_URL } from "@/consts";

const items = [
  {
    header: (
      <div className="flex w-full items-center justify-center">
        <Image
          alt="AI Images"
          src={`${CDN_URL}/landing/features/ai-images.png`}
          className="w-full select-none"
          width={779}
          height={694}
          draggable={false}
        />
      </div>
    ),
    className: "md:col-span-1",
  },
  {
    header: (
      <div className="flex w-full items-center justify-center">
        <Image
          alt="AI Voiceovers"
          src={`${CDN_URL}/landing/features/ai-voiceovers.png`}
          className="w-full select-none"
          width={779}
          height={694}
          draggable={false}
        />
      </div>
    ),
    className: "md:col-span-1",
  },
  {
    header: (
      <div className="flex w-full items-center justify-center">
        <Image
          alt="AI Videos"
          src={`${CDN_URL}/landing/features/ai-videos.png`}
          className="w-full select-none"
          width={779}
          height={694}
          draggable={false}
        />
      </div>
    ),
    className: "md:col-span-1",
  },
  {
    header: (
      <div className="flex w-full items-center justify-center">
        <Image
          alt="Download Social Videos"
          src={`${CDN_URL}/landing/features/social-downloader.png`}
          className="w-full select-none"
          width={779}
          height={694}
          draggable={false}
        />
      </div>
    ),
    className: "md:col-span-1",
  },
  {
    header: (
      <div className="flex w-full items-center justify-center">
        <Image
          alt="Image and Video Background Remover"
          src={`${CDN_URL}/landing/features/remove-bg.png`}
          className="w-full select-none"
          width={779}
          height={694}
          draggable={false}
        />
      </div>
    ),
    className: "md:col-span-1",
  },
  {
    header: (
      <div className="flex w-full items-center justify-center">
        <Image
          alt="Brainstorm Content Ideas"
          src={`${CDN_URL}/landing/features/brainstorm.png`}
          className="w-full select-none"
          width={779}
          height={694}
          draggable={false}
        />
      </div>
    ),
    className: "md:col-span-1",
  },
  {
    header: (
      <div className="flex w-full items-center justify-center">
        <Image
          alt="Speech Enhancer"
          src={`${CDN_URL}/landing/features/speech-enhancer.png`}
          className="w-full select-none"
          width={1184}
          height={694}
          draggable={false}
        />
      </div>
    ),
    className: "md:col-span-1",
  },
  {
    header: (
      <div className="flex w-full items-center justify-center">
        <Image
          alt="Vocal Remover"
          src={`${CDN_URL}/landing/features/vocal-remover.png`}
          className="w-full select-none"
          width={1184}
          height={694}
          draggable={false}
        />
      </div>
    ),
    className: "md:col-span-1",
  },
];

const FeaturesBento = () => {
  return (
    <BasicBlock
      header="Crayo has everything you need to go viral"
      mobileHeader="Countless Tools"
      subHeader="From cutting-edge speech enhancement to downloading videos, we've got you covered."
      contentStyle="flex-col gap-4"
      wrapperStyle="md:mt-10 md:gap-10"
    >
      <BentoGrid>
        {items.slice(0, 6).map((item, i) => (
          <BentoGridItem key={i} header={item.header} className={cn(item.className)} />
        ))}
      </BentoGrid>
      <BentoGrid className="md:grid-cols-2">
        {items.slice(6, 8).map((item, i) => (
          <BentoGridItem key={i} header={item.header} className={cn(item.className)} />
        ))}
      </BentoGrid>
    </BasicBlock>
  );
};

export default FeaturesBento;
